import { createFileRoute } from '@tanstack/react-router'
import { Wallet } from '../../../../../ui'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/wallet',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return <Wallet />
}
